type Status = {
  value: 'ATIVO' | 'BLOQUEADO' | string;
  id: string;
}[];

export const statusOptions: Status = [
  { value: 'ATIVO', id: 'ATIVO' },
  { value: 'BLOQUEADO', id: 'BLOQUEADO' },
];
